import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CurrencyPipe } from '@angular/common';
import { ARService } from '../../ar.service';
import { DataARLedgerListModel } from '../../models/data-ar-ledger-list.model';
import { UiService } from 'src/app/services/ui.service';
import { VoidValidationModel } from 'src/app/models/accountsReceivable/void-validation.model';

@Component({
  selector: 'app-ar-ledger-charge-void',
  templateUrl: './ar-ledger-charge-void.component.html',
  styleUrls: ['./ar-ledger-charge-void.component.scss']
})
export class ArLedgerChargeVoidComponent implements OnInit, OnDestroy {


  isLoading: boolean = false;
  itemToVoid: DataARLedgerListModel;
  voidReason: string = '';
  validationResult: VoidValidationModel;
  validateSubscription: any;

  constructor(
    public dialogRef: MatDialogRef<ArLedgerChargeVoidComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly arService: ARService,
    private readonly dialog: MatDialog,
    private readonly currencyPipe: CurrencyPipe,
    public readonly uiService: UiService,
  ) { }

  ngOnDestroy(): void {
    if (this.validateSubscription) {
      this.validateSubscription.unsubscribe();
      this.validateSubscription = false;
    }
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.itemToVoid = this.data.paymentLedgerItemToVoid;
    console.log("ArLedgerChargeVoidComponent data", this.data);
    this.init();

  }


  async init() {
    // save ledger status change
    this.isLoading = true;

    this.validateSubscription = this.arService.validateChargeVoid(this.itemToVoid.LedgerID).subscribe(result => {
      this.isLoading = false;
      this.validationResult = result;
      console.log('ArLedgerChargeVoidComponent validateChargeVoid result', result);
      if (result) {
        // save successful
        if (!this.validationResult.IsValid) {
          this.uiService.displayMessage('Warning', 'Item invalid');
        }
        // reload ledger
        try {
          console.log('ArLedgerChargeVoidComponent ledgerupdatesub CALL INIT');
        } catch (err) {
          console.log(err);
          this.uiService.displayMessage('Error', 'Something went wrong',);
          this.isLoading = false;
        }
      }
    }, err => {
      this.isLoading = false;
      this.uiService.displayMessage('Error', 'Error validating charge void',);
    });
  }

  processVoid() {
    console.log('ArLedgerChargeVoidComponent processVoid', this.voidReason);
    if (this.voidReason == null || this.voidReason == '') {
      this.uiService.displayMessage('Warning', 'Please enter a void reason.');
      return;
    }
    this.close(this.voidReason);
  }

  close(payload) {
    this.dialogRef.close(payload);
  }

}
